export default __webpack_public_path__ + "static/media/bci-12.077fb4cc.svg";